module.exports = __webpack_public_path__ + "static/img/mall.2fb9aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/mall.png
// module id = tT56
// module chunks = 226